import { http } from './http'
import { Coin, CoinCreate } from '../../common/models'

export const createCoin = (data: CoinCreate) =>
  http.post(`/operations/coins`, data)

export const getCoin = () => http.get<Coin[]>('/operations/coins')

export const deleteCoin = (id: string) => http.delete(`/operations/coins/${id}`)

export const updateCoin = (id: string, data: CoinCreate) =>
  http.put<Coin>(`/operations/coins/${id}`, data)
